<dashboard-loader
  *ngIf="(loadingCcStudyParticipants$ | async) || (loadingSelectedStudy$ | async)"
  [title]="'Loading Participants...'"
></dashboard-loader>
<div
  class="dashboard-cc-study-participants"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
  *ngIf="(ccStudyParticipantsLoaded$ | async) && (selectedStudyLoaded$ | async)"
>
  <div class="dashboard-cc-study-participants__header" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="dashboard-cc-study-participants__header-title">Participants</div>
  </div>
  <div
    *ngIf="!ccStudyParticipants?.length; else participantsTable"
    class="dashboard-cc-study-participants__message"
    fxLayout="column"
  >
    No participants have been subscribed to this study.
  </div>
  <ng-template #participantsTable>
    <div class="dashboard-cc-study-participants__table-holder">
      <table mat-table [dataSource]="ccStudyParticipants" class="dashboard-cc-study-participants__table-holder-table">
        <ng-container [matColumnDef]="DEFAULT_COLUMNS_TO_DISPLAY.PARTICIPANTS">
          <th mat-header-cell *matHeaderCellDef>Participant</th>
          <td mat-cell *matCellDef="let ccStudyParticipant">
            {{ getCcStudyParticipantTableName(ccStudyParticipant) }}
          </td>
        </ng-container>

        <ng-container *ngFor="let intervention of interventions" [matColumnDef]="intervention.name">
          <th mat-header-cell *matHeaderCellDef>{{ intervention.name }}</th>
          <td mat-cell *matCellDef="let ccStudyParticipant">
            <ng-container
              *ngIf="
                getParticipantInterventionRelation(ccStudyParticipant, intervention) as participantAnswer;
                else noAnswer
              "
            >
              <ng-container *ngIf="participantAnswer?.userHash; else answerWithoutFeedback">
                <a href="#" (click)="copyFeedbackLinkToClipboard(participantAnswer); $event.preventDefault()">
                  {{ participantAnswer?.userHash }}
                </a>
              </ng-container>
            </ng-container>
            <ng-template #answerWithoutFeedback>
              <mat-icon>clear</mat-icon>
            </ng-template>
            <ng-template #noAnswer>-</ng-template>
          </td>
        </ng-container>

        <ng-container [matColumnDef]="DEFAULT_COLUMNS_TO_DISPLAY.REMOVE">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let ccStudyParticipant">
            <mat-icon
              class="dashboard-cc-study-participants__table-holder-table-row-cell--icon"
              #tooltip="matTooltip"
              matTooltip="Remove this participant"
              matTooltipPosition="above"
              color="primary"
              *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.PARTICIPANTS, PRIVILEGE_ACTIONS.ALL)"
              (click)="$event.stopPropagation(); deleteCcStudyParticipant(selectedStudy?.id, ccStudyParticipant?.id)"
            >
              delete
            </mat-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: columnsToDisplay"
          class="dashboard-cc-study-participants__table-row"
        ></tr>
      </table>
    </div>
  </ng-template>
</div>
